import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import type { UserDailyMission } from '../../../../../stores/daily-missions/types';
import { useStores } from '../../../../../stores/useStores';
import { formatTime } from '../../../../../utils/time';
import { GeneralWidgetTimer } from '../../GeneralWidget';

interface UpcomingDailyMissionWidgetTimerProps {
  event: UserDailyMission;
  extended?: boolean;
}

function UpcomingDailyMissionWidgetTimerComponent(props: UpcomingDailyMissionWidgetTimerProps) {
  const { extended } = props;
  const { t } = useTranslation();
  const { dailyMissionsStore, coinTypeStore } = useStores();
  const rawTimer = dailyMissionsStore.getRawTimer(coinTypeStore.coinType);
  if (!rawTimer) {
    return null;
  }
  const timer = formatTime(rawTimer, 's', t);

  return <GeneralWidgetTimer extended={extended} timerValue={timer} />;
}

export const UpcomingDailyMissionWidgetTimer = observer(UpcomingDailyMissionWidgetTimerComponent);
